import React, {FC} from 'react';
import styled from 'styled-components';

import {Handler, HandlerOf} from '../../../../../../libs/shared/helpers/src/react/reactHelpers';
import {Icon} from '../../../../../../libs/shared/ui/src/components/icon/icon';
import {useUserTheme} from '../../../../../../libs/shared/ui/src/theme/userThemeProvider';
import {RegexPart} from '../../../../editors/commons/stringTemplateModel';
import {Expression} from '../../../../editors/expressions/expressionModel';
import {ExpressionRef} from '../../../../editors/expressions/expressionRefModel';
import {StringTemplateParameter} from './stringTemplateParameter';

/*
 * Props.
 */

interface StringTemplateDropdownProps {
  expressions: ReadonlyArray<Expression>;
  isDisabled?: boolean;
  onPartSelected: HandlerOf<ExpressionRef | RegexPart>;
  canUsePreviousResult?: boolean;
  canUseRegex?: boolean;
  onSelectCreateExpression?: Handler;
}

/*
 * Styles.
 */

const StyledDropdownWrap = styled.div`
  display: flex;
  align-items: start;
  justify-content: space-between;
`;

const StyledDropdownChildrenWrap = styled.div`
  flex-grow: 1;
  display: flex;
  max-width: calc(100% - 20px);

  & > .tags-input {
    flex-grow: 1;
    width: 100%;
  }
`;

const StyledDropdownIcon = styled.div`
  margin-top: 3px;
`;

/*
 * Component.
 */

export const StringTemplateDropdown: FC<StringTemplateDropdownProps> = (props) => {
  const theme = useUserTheme();
  const {
    children,
    expressions,
    isDisabled,
    onPartSelected,
    canUsePreviousResult,
    canUseRegex,
    onSelectCreateExpression,
  } = props;

  const stringInput = <StyledDropdownChildrenWrap>{children}</StyledDropdownChildrenWrap>;

  if (!canUsePreviousResult && !canUseRegex && expressions.length === 0 && !onSelectCreateExpression) {
    return stringInput;
  }

  return (
    <StyledDropdownWrap>
      {stringInput}
      {!isDisabled && (
        <StringTemplateParameter
          expressions={expressions}
          selectedItem={null}
          onPartSelected={onPartSelected}
          canUsePreviousResult={canUsePreviousResult}
          canUseRegex={canUseRegex}
          renderButton={() => (
            <StyledDropdownIcon>
              <Icon name="plusCircleFilledSmall" color={theme.palette.blue.shade40} />
            </StyledDropdownIcon>
          )}
          onSelectCreateExpression={onSelectCreateExpression}
        />
      )}
    </StyledDropdownWrap>
  );
};
